import React, { useState, useEffect } from "react";
import { CurrencyInput } from "@picklebet/ui";
import { useFiatCurrency } from "@/hooks/firestore/user/useFiatCurrency";
import { convertAmountToCents, convertCentsToAmount } from "common/currency";

import { useBetslipStore } from "@/features/betslip/stores/betslipStore";
import { useSetStakeAll } from "@/features/betslip/hooks/useStakeActions";
import { QuickStakeChips } from "@/features/betslip/components/parts/QuickStakeChips";

import * as styles from "@/features/betslip/components/StakeAllSingles.module.scss";

export const StakeAllSingles = () => {
  const setStakeAll = useSetStakeAll();
  const fiatCurrency = useFiatCurrency();
  const singlesCount = useBetslipStore(
    (s) => s.singlesSectionSelections.length,
  );
  const submissionPhase = useBetslipStore((s) => s.submission.phase);
  const isPlacing = useBetslipStore((s) => s.isPlacing);
  const isReviewing = useBetslipStore((s) => s.isReviewing);

  const [cents, setCents] = useState(0);
  const [hasFocus, setHasFocus] = useState(false);

  useEffect(() => {
    if (submissionPhase === "idle" && !isPlacing && isReviewing) {
      setCents(0);
    }
  }, [submissionPhase, isPlacing, isReviewing]);

  const canStakeAll =
    singlesCount > 1 &&
    submissionPhase === "idle" &&
    !isPlacing &&
    !isReviewing;

  if (!canStakeAll) return null;

  const applyCents = (nextCents: number) => {
    setCents(nextCents);
    setStakeAll(nextCents);
  };

  return (
    <div className={styles.stakeAllWrapper} data-testid="stake-all-singles">
      <CurrencyInput
        currency={fiatCurrency}
        value={cents > 0 ? convertCentsToAmount(cents) : undefined}
        onChange={(dollars) => applyCents(convertAmountToCents(dollars))}
        label="Stake All Singles"
        canClear={false}
        onBlur={() => setHasFocus(false)}
        onFocus={() => setHasFocus(true)}
        containerClassName={styles.inputContainer}
        inputClassName={styles.input}
        wrapperClassName={styles.inputWrapper}
      />
      <div className={styles.quickStake}>
        <QuickStakeChips
          isOpen={hasFocus}
          valueCents={cents}
          onSetCents={applyCents}
          isPromo={false}
          showBalance={false}
          arrowOffset="calc(200% - 4px)"
          detached
        />
      </div>
    </div>
  );
};
